import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import React from "react";
import StatusChip, {
  TestRequestDisplayedState,
  TestRequestDisplayedStateStatus,
} from "../../components/Chip/StatusChip";
import { tesaBlue2, tesaBlue4, tesaGrey6 } from "../../styles/colors";

interface FilterTileProps {
  handleChange: (status: TestRequestDisplayedState, active: boolean) => void;
  isActive: boolean;
  matches: number;
  status: TestRequestDisplayedStateStatus;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: tesaGrey6,
    // important to override theme style
    "&.MuiPaper-root": { borderRadius: "8px !important" },
    "&:hover": {
      backgroundColor: tesaBlue4,
    },
    transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    width: "8.375rem",
  },
  activated: {
    backgroundColor: tesaBlue2,
  },
  textLarge: {
    fontFamily: "Proxima Nova Bold Condensed",
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.5,

    "&::after": {
      content: "'Requests'",
      fontFamily: "Proxima Nova",
      fontSize: "0.75rem",
      fontWeight: 400,
      letterSpacing: "0.4px",
      lineHeight: 1.25,
      marginLeft: "4px",
      verticalAlign: "middle",
    },
  },
});

const FilterTile: React.FC<FilterTileProps> = (props) => {
  const { handleChange, isActive, matches, status } = props;
  const classes = useStyles();

  const handleClick = () => {
    handleChange(status.state, !isActive);
  };

  return (
    <Card
      className={isActive ? [classes.root, classes.activated].join(" ") : classes.root}
      onClick={handleClick}
      square={false}
    >
      <CardActionArea>
        <CardContent>
          <div>
            <span className={classes.textLarge}>{matches}</span>
          </div>
          <StatusChip status={status} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default FilterTile;
